export const dramas = [
  {
    id: "drama-001",
    title: "长安烟雨录",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20historical%20drama%20poster%2C%20misty%20rain%20over%20ancient%20city%20walls%2C%20warm%20gold%20lanterns%2C%20deep%20blue%20night%20sky%2C%20elegant%20poetic%20mood%2C%20high%20detail&width=400&height=600&seq=drama-changan-rain-01&orientation=portrait",
    genre: "古装 权谋",
    type: "costume",
    region: "中国大陆",
    year: 2025,
    episodes: 40,
    director: "陈望舒",
    cast: ["林清月", "沈砚舟", "江北辰"],
    castIds: ["actor-lin", "actor-shen", "actor-jiang"],
    rating: 9.2,
    popularity: 9980,
    tags: ["热播", "高口碑", "权谋", "群像"],
    synopsis:
      "大唐长安，一场连绵烟雨揭开二十年前的旧案。女官苏衡（林清月 饰）因一卷密档卷入朝堂纷争，与冷面将军裴照（沈砚舟 饰）从相互试探到并肩查案。线索指向一桩被刻意掩埋的宫闱秘辛，也指向苏衡自己的身世。权谋、情义与抉择在烟雨长安中层层交织，每个人都必须在真相与立场之间做出选择。",
    episodeGuide: [
      {
        episode: 1,
        title: "烟雨入长安",
        content:
          "连绵烟雨中，苏衡以新任女官身份入宫。一卷被雨水浸湿的密档让她在无意间窥见旧案一角，也让她成为多方势力关注的焦点。",
      },
      {
        episode: 2,
        title: "将军夜访",
        content:
          "裴照深夜到访，以查案之名试探苏衡的底细。两人言辞交锋，却在一处细节上意外达成默契，决定暂时联手。",
      },
      {
        episode: 3,
        title: "密档失踪",
        content:
          "存放密档的库房被人闯入，关键卷宗不翼而飞。苏衡发现看守记录中有被篡改的痕迹，怀疑宫中有内应。",
      },
      {
        episode: 4,
        title: "旧案初现",
        content:
          "顺着线索，两人找到一位退隐的老画师。老画师口中的往事，让二十年前的那桩宫闱秘辛第一次浮出水面。",
      },
    ],
    updatedAt: "2025-10-08",
    status: "更新至 32 集",
  },
  {
    id: "drama-002",
    title: "都市迷航",
    cover: "https://readdy.ai/api/search-image?query=Moody%20modern%20urban%20thriller%20poster%2C%20lone%20figure%20on%20a%20rainy%20neon%20street%2C%20cool%20blue%20tones%20with%20warm%20amber%20highlights%2C%20cinematic%20atmosphere&width=400&height=600&seq=drama-city-lost-01&orientation=portrait",
    genre: "都市 悬疑",
    type: "suspense",
    region: "中国大陆",
    year: 2025,
    episodes: 36,
    director: "方之衡",
    cast: ["顾南亭", "苏晚晴", "陆行舟"],
    castIds: ["actor-gu", "actor-su", "actor-lu"],
    rating: 8.9,
    popularity: 9640,
    tags: ["悬疑", "都市", "反转", "热播"],
    synopsis:
      "深夜的城市总有它不愿示人的一面。侦探顾问江屿（顾南亭 饰）接手一桩看似普通的失踪案，却在调查中发现自己三年前的旧案与之惊人相似。记者温晚（苏晚晴 饰）为了独家线索与他同行，两人在灯火阑珊的都市里，一步步走进被精心设计的迷局。每一个证人都没有说谎，但真相依然藏在迷雾深处。",
    episodeGuide: [
      {
        episode: 1,
        title: "深夜来电",
        content:
          "一通凌晨的求助电话把江屿拽回侦探工作。报案人称妹妹失踪三天，而现场唯一的线索是一张被撕掉一半的照片。",
      },
      {
        episode: 2,
        title: "相似的案件",
        content:
          "江屿在整理旧案卷宗时，惊讶地发现失踪案的细节与自己三年前经手的案件几乎一模一样，背后似有隐情。",
      },
      {
        episode: 3,
        title: "记者的线索",
        content:
          "温晚带来一份未经发表的采访记录，其中一名证人的证词与警方笔录存在关键出入，案件出现第一个裂口。",
      },
      {
        episode: 4,
        title: "监控盲区",
        content:
          "调取监控后，两人发现失踪者最后出现的位置恰好是监控盲区。江屿意识到，有人对这座城市的摄像头了如指掌。",
      },
    ],
    updatedAt: "2025-10-06",
    status: "更新至 28 集",
  },
  {
    id: "drama-003",
    title: "星辰与你",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20modern%20drama%20poster%2C%20young%20couple%20under%20a%20starry%20night%20sky%2C%20soft%20warm%20light%2C%20dreamy%20pastel%20and%20deep%20blue%20tones%2C%20romantic%20mood&width=400&height=600&seq=drama-stars-you-01&orientation=portrait",
    genre: "都市 爱情",
    type: "romance",
    region: "中国大陆",
    year: 2024,
    episodes: 32,
    director: "苏婉",
    cast: ["温之夏", "江北辰", "白清欢"],
    castIds: ["actor-wen", "actor-jiang", "actor-bai"],
    rating: 8.6,
    popularity: 8910,
    tags: ["甜宠", "双向奔赴", "治愈", "高口碑"],
    synopsis:
      "天文台研究员沈星（温之夏 饰）与误打误撞闯入观测站的摄影师顾言（江北辰 饰）因一场流星雨相识。一个痴迷于遥远的星光，一个执著于记录身边的温度。两人从互不理解到彼此照亮，在无数次追星的旅途中，也慢慢看清了自己的内心。这是一部关于梦想、坚持与温柔陪伴的爱情故事。",
    episodeGuide: [
      {
        episode: 1,
        title: "流星雨之夜",
        content:
          "为拍摄一年一度的流星雨，摄影师顾言误入天文台观测禁区，与正在值守的沈星发生了一场啼笑皆非的争执。",
      },
      {
        episode: 2,
        title: "错位的照片",
        content:
          "顾言发现自己的相机里多了一张沈星仰望星空的照片，而沈星则收到了他留下的道歉纸条。两人的故事由此开始。",
      },
      {
        episode: 3,
        title: "观测站的雨",
        content:
          "一场突如其来的暴雨让两人被困观测站。彻夜长谈中，他们第一次向对方聊起各自不愿提及的过去。",
      },
      {
        episode: 4,
        title: "一颗新星",
        content:
          "沈星参与的项目发现一颗新的变星，兴奋之余却得知项目面临被裁撤的危机，顾言提出用自己的方式帮她留下证据。",
      },
    ],
    updatedAt: "2025-09-18",
    status: "已完结",
  },
  {
    id: "drama-004",
    title: "山河故人梦",
    cover: "https://readdy.ai/api/search-image?query=Nostalgic%20period%20drama%20poster%2C%20countryside%20sunset%20with%20distant%20mountains%2C%20faded%20warm%20sepia%20tones%2C%20memory%20and%20family%20theme%2C%20cinematic&width=400&height=600&seq=drama-mountain-dream-01&orientation=portrait",
    genre: "年代 家庭",
    type: "family",
    region: "中国大陆",
    year: 2024,
    episodes: 45,
    director: "赵怀民",
    cast: ["沈砚舟", "林清月", "陆行舟"],
    castIds: ["actor-shen", "actor-lin", "actor-lu"],
    rating: 9.0,
    popularity: 8320,
    tags: ["年代", "家庭", "群像", "催泪"],
    synopsis:
      "从上世纪八十年代到新世纪初，一座南方小城里的陈家三兄妹在时代变迁中各自成长。大哥陈建国（沈砚舟 饰）扛起家业，二姐陈小满（林清月 饰）远走他乡追寻理想，三弟陈安（陆行舟 饰）留守故土守护老宅。三十年光阴流转，山河依旧，故人入梦，家的意义在离别与重逢中被重新定义。",
    episodeGuide: [
      {
        episode: 1,
        title: "老宅的夏天",
        content:
          "1982 年的夏天，陈家老宅里充满蝉鸣与笑声。父亲的一纸调令，让三个孩子的命运悄然转向。",
      },
      {
        episode: 2,
        title: "离乡的站台",
        content:
          "二姐陈小满拿到了远方的录取通知书。站台上，兄妹三人第一次体会到离别的不舍与时代的召唤。",
      },
      {
        episode: 3,
        title: "信里的远方",
        content:
          "一封封家书串联起彼此时空。大哥在信中隐藏了家中的困难，只为让远方的妹妹安心求学。",
      },
      {
        episode: 4,
        title: "归来的人",
        content:
          "多年后，陈小满带着满身故事回到小城。老宅的门槛上，坐着已经长大的弟弟和白了头的大哥。",
      },
    ],
    updatedAt: "2025-08-30",
    status: "已完结",
  },
  {
    id: "drama-005",
    title: "深巷之光",
    cover: "https://readdy.ai/api/search-image?query=Suspense%20drama%20poster%2C%20dark%20narrow%20alley%20with%20a%20single%20warm%20light%20at%20the%20end%2C%20high%20contrast%2C%20mysterious%20atmosphere%2C%20cinematic&width=400&height=600&seq=drama-alley-light-01&orientation=portrait",
    genre: "悬疑 罪案",
    type: "suspense",
    region: "中国大陆",
    year: 2025,
    episodes: 30,
    director: "罗清野",
    cast: ["苏晚晴", "顾南亭", "温之夏"],
    castIds: ["actor-su", "actor-gu", "actor-wen"],
    rating: 9.1,
    popularity: 9480,
    tags: ["悬疑", "罪案", "烧脑", "热播"],
    synopsis:
      "老城区的一条深巷里，接连发生了几起看似意外的案件。刑警队长宋野（顾南亭 饰）与法医程知微（苏晚晴 饰）联手调查，发现所有线索都指向一家已经倒闭多年的照相馆。深巷的尽头究竟藏着什么？当真相被层层揭开，他们才发现，最亮的那束光，照见的往往是最深的黑暗。",
    episodeGuide: [
      {
        episode: 1,
        title: "巷口的第一盏灯",
        content:
          "深巷中一位老人离奇身亡，现场没有任何挣扎痕迹。程知微在尸检中发现了不合常理的细节。",
      },
      {
        episode: 2,
        title: "褪色的照片",
        content:
          "死者遗物中一张褪色的老照片引起宋野的注意。照片背景正是那家倒闭的照相馆。",
      },
      {
        episode: 3,
        title: "沉默的邻居",
        content:
          "走访中，巷子里的邻居们口径出奇一致，这种刻意的沉默反而让宋野确定，这里藏着秘密。",
      },
      {
        episode: 4,
        title: "暗房里的底片",
        content:
          "两人设法进入废弃照相馆的暗房，找到一批未冲洗的底片，其中一张记录了多年前的真相。",
      },
    ],
    updatedAt: "2025-10-09",
    status: "更新至 24 集",
  },
  {
    id: "drama-006",
    title: "春风十里长街",
    cover: "https://readdy.ai/api/search-image?query=Warm%20urban%20drama%20poster%2C%20sunny%20city%20street%20lined%20with%20cherry%20blossoms%2C%20gentle%20soft%20light%2C%20cozy%20hopeful%20atmosphere%2C%20cinematic&width=400&height=600&seq=drama-spring-street-01&orientation=portrait",
    genre: "都市 生活",
    type: "urban",
    region: "中国大陆",
    year: 2024,
    episodes: 34,
    director: "梁遇安",
    cast: ["白清欢", "温之夏", "江北辰"],
    castIds: ["actor-bai", "actor-wen", "actor-jiang"],
    rating: 8.4,
    popularity: 7760,
    tags: ["都市", "治愈", "生活", "群像"],
    synopsis:
      "长街是一条有着百年历史的老商业街，街坊邻里彼此熟识。随着城市更新计划的推进，长街面临拆迁。咖啡店老板唐糖（白清欢 饰）与几位年轻邻居决定用自己的方式守护这条街。在一次次啼笑皆非的行动中，他们重新认识了彼此，也找到了属于自己人生的方向。",
    episodeGuide: [
      {
        episode: 1,
        title: "长街的早晨",
        content:
          "唐糖的咖啡店开张第一天就遇上停水停电，隔壁花店姑娘和修表师傅纷纷伸出援手，长街的人情味初现。",
      },
      {
        episode: 2,
        title: "拆迁公告",
        content:
          "拆迁公告贴出的那天，长街炸开了锅。唐糖在公告前站了很久，第一次认真思考自己能做些什么。",
      },
      {
        episode: 3,
        title: "守护计划",
        content:
          "几位年轻人凑在一起，决定为长街办一场市集，让更多人看到这条街的价值。",
      },
      {
        episode: 4,
        title: "第一场市集",
        content:
          "市集当天人潮涌动，却也遇到了意外状况。大家一起应对的过程中，感情悄然升温。",
      },
    ],
    updatedAt: "2025-07-22",
    status: "已完结",
  },
  {
    id: "drama-007",
    title: "大漠孤烟",
    cover: "https://readdy.ai/api/search-image?query=Epic%20wuxia%20drama%20poster%2C%20desert%20dunes%20with%20a%20lone%20swordsman%20silhouette%2C%20orange%20sunset%2C%20dramatic%20sky%2C%20heroic%20cinematic%20mood&width=400&height=600&seq=drama-desert-smoke-01&orientation=portrait",
    genre: "古装 武侠",
    type: "costume",
    region: "中国大陆",
    year: 2025,
    episodes: 38,
    director: "赫连风",
    cast: ["江北辰", "沈砚舟", "苏晚晴"],
    castIds: ["actor-jiang", "actor-shen", "actor-su"],
    rating: 8.8,
    popularity: 9060,
    tags: ["武侠", "热血", "江湖", "热播"],
    synopsis:
      "大漠边关，孤烟直上。落魄剑客沈孤鸿（江北辰 饰）为寻访师门旧仇，一路西行。途中他救下被追杀的商队少女，卷入一场关乎江湖格局的纷争。刀光剑影之间，昔日情义与今日恩怨纠缠不清。孤烟起处，是归途，还是另一个风起云涌的开始？",
    episodeGuide: [
      {
        episode: 1,
        title: "沙丘之约",
        content:
          "沈孤鸿在沙丘中救下被追杀的商队少女，一把旧剑揭开了他尘封多年的身世。",
      },
      {
        episode: 2,
        title: "边城酒肆",
        content:
          "边城酒肆里，沈孤鸿与仇家手下狭路相逢。一场试探性的交手，让他意识到对手远比想象中强大。",
      },
      {
        episode: 3,
        title: "故人重逢",
        content:
          "旧日同门突然现身，带来师门覆灭的真相碎片，也带来了无法拒绝的条件。",
      },
      {
        episode: 4,
        title: "孤烟直上",
        content:
          "为护送商队穿过隘口，沈孤鸿独战群敌。大漠孤烟之下，一个身影站成了一座丰碑。",
      },
    ],
    updatedAt: "2025-10-04",
    status: "更新至 30 集",
  },
  {
    id: "drama-008",
    title: "硅谷玫瑰",
    cover: "https://readdy.ai/api/search-image?query=Modern%20workplace%20drama%20poster%2C%20glass%20office%20towers%20at%20dusk%2C%20cool%20blue%20tones%20with%20warm%20accent%20light%2C%20sleek%20professional%20cinematic%20mood&width=400&height=600&seq=drama-silicon-rose-01&orientation=portrait",
    genre: "现代 职场",
    type: "modern",
    region: "中国大陆",
    year: 2025,
    episodes: 36,
    director: "程越",
    cast: ["温之夏", "陆行舟", "白清欢"],
    castIds: ["actor-wen", "actor-lu", "actor-bai"],
    rating: 8.3,
    popularity: 7480,
    tags: ["职场", "女性成长", "创业", "群像"],
    synopsis:
      "海归工程师周妍（温之夏 饰）带着自主研发的算法回国创业，加入了一家年轻的科技公司。在男性主导的技术行业里，她既要面对质疑，也要应对资本的博弈。合伙人陆则（陆行舟 饰）与她是理念上的对手、行动上的同路人。当公司走到生死关口，周妍必须做出抉择：是妥协求生，还是坚持到底。",
    episodeGuide: [
      {
        episode: 1,
        title: "回国第一天",
        content:
          "周妍带着算法模型入职，却在第一次产品会上遭遇质疑。她用一组数据回击，也让陆则记住了她。",
      },
      {
        episode: 2,
        title: "融资危机",
        content:
          "公司账上资金告急，投资人提出苛刻条件。周妍与陆则在会议室里第一次正面交锋。",
      },
      {
        episode: 3,
        title: "深夜加班",
        content:
          "为了赶在演示前修复系统漏洞，团队通宵鏖战。周妍和陆则在便利店的灯光下短暂地放下了立场之争。",
      },
      {
        episode: 4,
        title: "第一笔订单",
        content:
          "产品终于拿下第一笔订单，团队欢呼雀跃。但周妍发现，这份合同的背后另有隐情。",
      },
    ],
    updatedAt: "2025-10-02",
    status: "更新至 26 集",
  },
  {
    id: "drama-009",
    title: "四时安好",
    cover: "https://readdy.ai/api/search-image?query=Heartwarming%20family%20drama%20poster%2C%20cozy%20living%20room%20with%20warm%20afternoon%20light%20through%20windows%2C%20soft%20tones%2C%20gentle%20domestic%20mood&width=400&height=600&seq=drama-four-seasons-01&orientation=portrait",
    genre: "家庭 治愈",
    type: "family",
    region: "中国大陆",
    year: 2023,
    episodes: 40,
    director: "许念之",
    cast: ["林清月", "白清欢", "顾南亭"],
    castIds: ["actor-lin", "actor-bai", "actor-gu"],
    rating: 8.7,
    popularity: 8120,
    tags: ["家庭", "治愈", "生活", "高分"],
    synopsis:
      "老裁缝秦奶奶（林清月 饰）独自守着开了四十年的裁缝铺。孙子秦朗（顾南亭 饰）因工作受挫回到老城，原本打算短暂停留，却在陪奶奶缝补衣物的日子里，重新梳理了自己的人生。四季流转，一针一线，缝起的是一个家族的温情与和解。",
    episodeGuide: [
      {
        episode: 1,
        title: "回来的行李箱",
        content:
          "秦朗拖着行李箱回到老城，奶奶没有多问，只是默默在饭桌上多加了一副碗筷。",
      },
      {
        episode: 2,
        title: "旧缝纫机",
        content:
          "奶奶的缝纫机坏了，秦朗想换新的，奶奶却坚持要修——那台机器承载着半个家的记忆。",
      },
      {
        episode: 3,
        title: "一件旧衣裳",
        content:
          "一位老主顾带来一件放了很多年的衣裳，想请奶奶修改。衣裳背后的故事，让秦朗陷入沉思。",
      },
      {
        episode: 4,
        title: "春天的订单",
        content:
          "裁缝铺接到了改造旧衣的批量订单，秦朗第一次认真帮奶奶打理起这间并不起眼的小店。",
      },
    ],
    updatedAt: "2025-06-15",
    status: "已完结",
  },
  {
    id: "drama-010",
    title: "逆光而行",
    cover: "https://readdy.ai/api/search-image?query=Youth%20suspense%20drama%20poster%2C%20teenagers%20running%20toward%20backlit%20sunlight%20in%20a%20corridor%2C%20hopeful%20yet%20tense%20mood%2C%20cinematic%20dusty%20light&width=400&height=600&seq=drama-backlight-01&orientation=portrait",
    genre: "青春 悬疑",
    type: "suspense",
    region: "中国大陆",
    year: 2024,
    episodes: 28,
    director: "应无期",
    cast: ["苏晚晴", "江北辰", "温之夏"],
    castIds: ["actor-su", "actor-jiang", "actor-wen"],
    rating: 8.5,
    popularity: 7940,
    tags: ["青春", "悬疑", "成长", "反转"],
    synopsis:
      "高三那年，一段被删除的校园监控视频，让四个少年的命运彻底改变。转学生林晚（苏晚晴 饰）为了查明好友意外的真相，与几个性格迥异的同学结成联盟。他们一边备战高考，一边在成人的谎言中寻找出口。逆着光的方向奔跑，是为了看清黑暗的尽头是否有出口。",
    episodeGuide: [
      {
        episode: 1,
        title: "消失的十七分钟",
        content:
          "校园监控在事发当天出现十七分钟空白。转学生林晚注意到这个细节，决定自己查下去。",
      },
      {
        episode: 2,
        title: "天台上的赌约",
        content:
          "四个少年在天台上立下赌约：在毕业前查清真相。他们分工协作，关系也在摩擦中逐渐靠近。",
      },
      {
        episode: 3,
        title: "被撕掉的日记",
        content:
          "好友留下的日记缺了最关键的一页。林晚循着字迹的压痕，拼凑出一段被隐瞒的往事。",
      },
      {
        episode: 4,
        title: "成人的沉默",
        content:
          "当调查触及到成年人时，所有人都选择了沉默。少年们意识到，真相的代价可能远超想象。",
      },
    ],
    updatedAt: "2025-09-10",
    status: "已完结",
  },
  {
    id: "drama-011",
    title: "白露为霜",
    cover: "https://readdy.ai/api/search-image?query=Elegant%20ancient%20romance%20drama%20poster%2C%20pale%20moonlight%20over%20a%20lotus%20pond%2C%20soft%20blue%20and%20silver%20tones%2C%20delicate%20poetic%20mood%2C%20high%20detail&width=400&height=600&seq=drama-white-dew-01&orientation=portrait",
    genre: "古装 爱情",
    type: "costume",
    region: "中国大陆",
    year: 2024,
    episodes: 36,
    director: "云清和",
    cast: ["林清月", "江北辰", "沈砚舟"],
    castIds: ["actor-lin", "actor-jiang", "actor-shen"],
    rating: 8.9,
    popularity: 8640,
    tags: ["古装", "爱情", "唯美", "高口碑"],
    synopsis:
      "白露那日，江南名门之女苏霜（林清月 饰）在荷塘边救下一名失忆的落水贵公子。两人在乡野间度过了一段不被打扰的静好时光，直到男子的身份被人揭开——他竟是当今圣上最忌惮的王爷。爱情与家国、身世与立场，让这段缘分如白露为霜，短暂而清冷。",
    episodeGuide: [
      {
        episode: 1,
        title: "荷塘落水",
        content:
          "白露清晨，苏霜在荷塘边发现一名落水男子。她将其救起，却发现他失去了所有记忆。",
      },
      {
        episode: 2,
        title: "无名之客",
        content:
          "男子自称记不得姓名，苏霜便唤他“白露”。两人在乡野间度过了一段安静的时光。",
      },
      {
        episode: 3,
        title: "玉佩的秘密",
        content:
          "男子随身玉佩上的纹样被访客认出，指向一个显赫又危险的身份。",
      },
      {
        episode: 4,
        title: "诀别之前",
        content:
          "身份揭开在即，苏霜选择放手。离别前一晚，两人在荷塘边没有说一句话。",
      },
    ],
    updatedAt: "2025-08-05",
    status: "已完结",
  },
  {
    id: "drama-012",
    title: "午夜列车",
    cover: "https://readdy.ai/api/search-image?query=Crime%20thriller%20poster%2C%20night%20train%20with%20glowing%20windows%20speeding%20through%20darkness%2C%20dark%20moody%20tones%2C%20suspenseful%20cinematic%20atmosphere&width=400&height=600&seq=drama-midnight-train-01&orientation=portrait",
    genre: "悬疑 犯罪",
    type: "suspense",
    region: "中国大陆",
    year: 2025,
    episodes: 24,
    director: "殷泽",
    cast: ["陆行舟", "顾南亭", "苏晚晴"],
    castIds: ["actor-lu", "actor-gu", "actor-su"],
    rating: 8.7,
    popularity: 8860,
    tags: ["犯罪", "悬疑", "密室", "烧脑"],
    synopsis:
      "一趟开往北方的午夜列车，十二节车厢，三百余名乘客，却在一个信号中断的隧道里失去了与外界的所有联系。当列车重新驶出隧道，一名乘客离奇失踪，而所有人的记忆里都没有他存在过的痕迹。刑警出身的乘客程野（陆行舟 饰）决定在下车前找出真相——因为这趟列车上，说谎的不止一个人。",
    episodeGuide: [
      {
        episode: 1,
        title: "隧道之后",
        content:
          "列车驶出隧道后，一名乘客凭空消失，乘务员的名单上也没有他的名字。",
      },
      {
        episode: 2,
        title: "三百个陌生人",
        content:
          "程野开始逐一排查乘客。每个人都提供了一条线索，也每个人都隐藏了一点什么。",
      },
      {
        episode: 3,
        title: "反锁的车厢",
        content:
          "一节车厢的门从内部反锁，里面空无一人。程野在通风口发现了不属于任何乘客的物品。",
      },
      {
        episode: 4,
        title: "第一节车厢",
        content:
          "线索最终指向了第一节车厢——那节所有人都以为不存在的车厢。",
      },
    ],
    updatedAt: "2025-10-10",
    status: "更新至 18 集",
  },
];